import api from 'constants/api';
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || '',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '',
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL || '',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || '',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || '',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '',
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || '',
};

const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY || '';

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

const clearLocalToken = async () => {
  return new Promise<void>((resolve, reject) => {
    if ('indexedDB' in window) {
      const DBDeleteRequest = indexedDB.deleteDatabase(
        'firebase-messaging-database',
      );
      DBDeleteRequest.onsuccess = () => {
        console.log(
          '🗑️ Old IndexedDB database deleted successfully',
          DBDeleteRequest.result,
        );
        resolve();
      };
      DBDeleteRequest.onerror = () => {
        console.error(
          '❌ Error deleting old IndexedDB database',
          DBDeleteRequest.error,
        );
        reject(DBDeleteRequest.error);
      };
      DBDeleteRequest.onblocked = () => {
        console.warn(
          '⚠️ Delete blocked: Please close all other tabs with this site open',
        );
      };
    } else {
      resolve();
    }
  });
};

// Registrar el service worker para Firebase Messaging
const registerServiceWorker = async () => {
  if ('serviceWorker' in navigator) {
    try {
      // Desregistrar cualquier SW existente primero
      const existingRegistrations =
        await navigator.serviceWorker.getRegistrations();
      for (const registration of existingRegistrations) {
        if (registration.scope.includes('firebase-messaging-sw')) {
          await registration.unregister();
          console.log('🗑️ Unregistered old Firebase SW');
        }
      }

      // Registrar el nuevo SW
      const registration = await navigator.serviceWorker.register(
        '/firebase-messaging-sw.js',
        {
          scope: '/',
          updateViaCache: 'none',
        },
      );

      // Esperar a que esté completamente activo
      await navigator.serviceWorker.ready;

      console.log('✅ Service Worker registered and ready:', registration);
      return registration;
    } catch (error) {
      console.error('❌ Service Worker registration failed:', error);
      return null;
    }
  }
  return null;
};

export const requestForToken = async () => {
  try {
    console.log('🔄 Starting FCM token request...');

    const permission = await Notification.requestPermission();
    console.log(`📋 Notification permission: ${permission}`);

    if (permission !== 'granted') {
      console.error('❌ Notification permission denied');
      return null;
    }

    // Registrar el service worker
    const registration = await registerServiceWorker();
    if (!registration) {
      console.error('❌ Service Worker registration failed');
      return null;
    }

    // Clear any existing token on the indexdb to avoid old tokens
    await clearLocalToken();
    console.log('🔄 Requesting FCM token...');
    const currentToken = await getToken(messaging, {
      vapidKey,
      serviceWorkerRegistration: registration,
    });

    if (currentToken) {
      console.log('✅ FCM Token generated:', currentToken);
      return currentToken;
    }

    console.error('❌ No registration token available');
    return null;
  } catch (err) {
    if (err instanceof Error) {
      console.error('❌ Error retrieving token:', err);
      console.error('❌ Error message:', err.message);
      return null;
    }
  }
};
